import { Pipe, PipeTransform } from '@angular/core';
import { TableCompositeCellType, TableHeaderCellModel, TableRowModel } from '@big-direkt/utils/shared';

@Pipe({
    name: 'responsiveTableDataStructurePipe',
})
export class ResponsiveTableDataStructurePipe implements PipeTransform {
    public transform(rows: TableRowModel, header: TableHeaderCellModel[] | null | undefined, isMobile: boolean): TableRowModel {
        if (!isMobile || !rows.length) {
            return rows;
        }

        return this.transformForMobile(rows, header ?? []);
    }

    private transformForMobile(rows: TableRowModel, header: TableHeaderCellModel[]): TableRowModel {
        const result: TableRowModel = [];

        // If headers are provided, use them
        if (header.length > 0) {
            for (let colIndex = 1; colIndex < header.length; colIndex++) {
                result.push(this.createRowForColumn(rows, header, colIndex));
            }
        }
        // If no headers are provided but rows exist, use the first cell of each row as the header
        else if (rows[0]?.length > 0) {
            // Use the first cell of each row as the header for that row
            for (const row of rows) {
                if (row.length > 1) {
                    const newRow: TableCompositeCellType[] = [];

                    // Use the first cell as the header
                    newRow.push(row[0]);

                    // Add the rest of the cells
                    for (let colIndex = 1; colIndex < row.length; colIndex++) {
                        newRow.push(row[colIndex]);
                    }

                    result.push(newRow);
                }
            }
        }

        return result;
    }

    private createRowForColumn(rows: TableRowModel, header: TableHeaderCellModel[], colIndex: number): TableCompositeCellType[] {
        const newRow: TableCompositeCellType[] = [];

        newRow.push({
            type: 'string',
            value: header[colIndex].value,
        });

        for (const originalRow of rows) {
            if (originalRow.length <= colIndex) {
                continue;
            }

            const titleValue = this.extractTitleValue(originalRow[0]);
            const valueCell = originalRow[colIndex];
            const newCell: TableCompositeCellType = {
                ...valueCell,
                title: titleValue,
            };

            newRow.push(newCell);
        }

        return newRow;
    }

    private extractTitleValue(titleCell: TableCompositeCellType): string {
        if (!('value' in titleCell)) {
            return '';
        }

        const { value } = titleCell;

        if (typeof value === 'string') {
            return value;
        }

        return '';
    }
}
